import React from 'react';
import Container from '../Container/Container.jsx';
import Navbar from '../../sections/Navbar/Navbar';
import Footer from '../../sections/Footer/Footer.jsx';

class Template extends React.Component {
  render() {
    const {
      displaySubNav,
      subNavLink,
      subNavLinkText,
      navigationColor,
      children,
      subNavTheme,
      colourChangeScrollThreshold,
      hideNavbar,
      hideFooter,
      partnerLegalName,
      customNavbar,
      customFooter,
    } = this.props;

    return (
      <Container displaySubNav={displaySubNav} hideNavbar={hideNavbar}>
        {!hideNavbar && customNavbar && (
          <Navbar
            sectionData={customNavbar}
            navigationColor={navigationColor} // Color of next module
            colourChangeScrollThreshold={colourChangeScrollThreshold} // Default back to forest after scroll
            subNav={{
              displaySubNav,
              subNavLink,
              subNavLinkText,
              subNavTheme,
            }}
          />
        )}
        {children}
        {!hideFooter && customFooter && (
          <Footer
            sectionData={customFooter}
            partnerLegalName={partnerLegalName}
          />
        )}
      </Container>
    );
  }
}

export default Template;
